<ng-container *ngIf="hasPermission$ | async as data">
  <ng-container *ngIf="data.hasPermission; else insufficientPermissions">
    <ng-container *ngTemplateOutlet="templateRef"></ng-container>
  </ng-container>

  <ng-template #insufficientPermissions>
    <p class="m-0">{{ 'validations.insufficientPermissions' | transloco }}</p>
  </ng-template>
</ng-container>

<ng-container *ngIf="!hasPermission$">
  <ng-container *ngIf="hasPermission; else notEnoughPermissions">
    <ng-container *ngTemplateOutlet="templateRef"></ng-container>
  </ng-container>

  <ng-template #notEnoughPermissions>
    <p class="m-0">{{ 'validations.insufficientPermissions' | transloco }}</p>
  </ng-template>
</ng-container>
